import { TransparentButton } from '@libs/components';
import { DropdownIcon } from 'src/assets';
import styled from 'styled-components';

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PreferredAssetsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  margin-top: 1.2rem;
`;

type TransparentButtonProps = {
  disabled?: boolean;
};
export const PreferredAssetWrapper = styled(
  TransparentButton
)<TransparentButtonProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  opacity: ${({ disabled }) => (disabled ? '50%' : '100%')};

  padding: 2rem 1.6rem;
  background-color: ${({ theme }) => theme.colors.surface.tertiary};

  border-radius: ${({ theme }) => theme.borderRadius.x5};
`;

export const ArrowIcon = styled(DropdownIcon)`
  width: 2.6rem;
`;

export const CustomImg = styled.img`
  max-width: 2rem;
  max-height: 2rem;
`;
